export function initNavSearch() {
	document.querySelectorAll( '.nav-search' ).forEach( ( wrap ) => {
		const btn = wrap.querySelector( '.wp-block-search__button' );
		const input = wrap.querySelector( '.wp-block-search__input' );
		if ( ! btn || ! input ) {
			return;
		}

		btn.addEventListener( 'click', ( e ) => {
			if ( ! wrap.classList.contains( 'is-open' ) ) {
				e.preventDefault();
				wrap.classList.add( 'is-open' );
				input.focus();
			}
			// If open but empty — close instead of submitting
			else if ( ! input.value.trim() ) {
				e.preventDefault();
				wrap.classList.remove( 'is-open' );
			}
			// If open with a value — let the form submit naturally
		} );

		input.addEventListener( 'keydown', ( e ) => {
			if ( e.key === 'Escape' ) {
				wrap.classList.remove( 'is-open' );
				btn.focus();
			}
		} );

		document.addEventListener( 'click', ( e ) => {
			if ( ! wrap.contains( e.target ) ) {
				wrap.classList.remove( 'is-open' );
			}
		} );
	} );
}
